import { render, staticRenderFns } from "./AdmissionExaminationSchedulerSave.vue?vue&type=template&id=4fc4b406&"
import script from "./AdmissionExaminationSchedulerSave.vue?vue&type=script&lang=js&"
export * from "./AdmissionExaminationSchedulerSave.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionExaminationSchedulerSave.vue?vue&type=style&index=0&id=4fc4b406&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports